import { GLP_LOGGED_COMPANY, GLP_LOGGED_PROFILE } from '../actions/types'

let currentCompany = {}
let currentUser = {}

try {
  currentCompany = JSON.parse(localStorage.getItem(GLP_LOGGED_COMPANY)) || {}
  currentUser = JSON.parse(localStorage.getItem(GLP_LOGGED_PROFILE)) || {}
} catch (err) {
  currentCompany = {}
  currentUser = {}
}

const initState = {
  companydata: currentCompany,
  userdata: currentUser,
  isLoading: false
}

const loggedInCompanyReducer = (state = initState, action) => {
  switch (action.type) {
  case GLP_LOGGED_COMPANY:
    return {
      ...state,
      userdata: currentUser
    }
  case 'FETCHING_COMPANY_DATA':
    return {
      ...state,
      isLoading: true
    }
  case 'FETCHED_COMPANY_DATA':
    // Only update if we have a logo - this prevents flickering
    if (action.companydata && (!state.companydata.logo || (action.companydata.logo && action.companydata.logo !== state.companydata.logo))) {
      return {
        ...state,
        companydata: action.companydata,
        isLoading: false
      }
    }
    return {
      ...state,
      isLoading: false
    }
  default:
    return {
      ...state
    }
  }
}

export default loggedInCompanyReducer
